import type {
  DevModeLifecycleHookEvent,
  DevModeLifecycleHookPhase
} from '@cli-types/next-adapter/generators.js'
export function lifecycleHookPhase(event: DevModeLifecycleHookEvent): DevModeLifecycleHookPhase {
  return event.startsWith('before') ? 'before' : 'after'
}
